var map = {
	"./csv.svg": 832,
	"./doc.svg": 833,
	"./file.svg": 834,
	"./mp3.svg": 835,
	"./mp4.svg": 836,
	"./pdf.svg": 837,
	"./txt.svg": 838,
	"./xls.svg": 839,
	"./xml.svg": 840,
	"./zip.svg": 841
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 980;


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/IconFileType/svg nonrecursive \.svg$
// module id = 980
// module chunks = 0